import { render } from "./EditPass.vue?vue&type=template&id=85ff7270"
import script from "./EditPass.vue?vue&type=script&lang=js"
export * from "./EditPass.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__